module.exports = __webpack_public_path__ + "static/media/stockhausen_polymorph_cover.4cf1c94c.jpg";